import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axios";

export const fetchGalleryImages = createAsyncThunk(
  "galleryImage/fetchAll",
  async ({ page = 1, limit = 10, search = "" } = {}, { rejectWithValue }) => {
    try {
      /* no wrapper here: the body is { data, pagination } */
      const res = await api.get(`/admin/content/gallery`, {
        params: { page, limit, search },
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to fetch images");
    }
  }
);

export const bulkUploadImages = createAsyncThunk(
  "galleryImage/bulkUpload",
  async (payload, { rejectWithValue }) => {
    try {
      /* JSON now: { urls: ["gallery/a.webp", ...], caption } — relative uploads
         paths, not files. Response is { message, data:[...] }, no status key. */
      const res = await api.post(`/admin/content/gallery`, payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Upload failed");
    }
  }
);

export const updateGalleryImage = createAsyncThunk(
  "galleryImage/update",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const res = await api.put(`/admin/content/gallery/${id}`, payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Update failed");
    }
  }
);

export const deleteGalleryImage = createAsyncThunk(
  "galleryImage/delete",
  async (id, { rejectWithValue }) => {
    try {
      /* an already-deleted row now answers 404, where Node answered 200 */
      await api.delete(`/admin/content/gallery/${id}`);
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Delete failed");
    }
  }
);

const galleryImageSlice = createSlice({
  name: "galleryImage",
  initialState: {
    images: [],
    loading: false,
    error: null,
    pagination: { page: 1, limit: 10, total: 0, totalPages: 1 },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchGalleryImages.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGalleryImages.fulfilled, (state, action) => {
        state.loading = false;
        state.images = action.payload.data;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchGalleryImages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteGalleryImage.fulfilled, (state, action) => {
        state.images = state.images.filter((img) => img.id !== action.payload);
      });
  },
});

export default galleryImageSlice.reducer;